export default __webpack_public_path__ + "989a680351d09e5ecb6b533a67c05853.png";